import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingCart, X, CheckCircle2 } from 'lucide-react';
const NAMES = ['María', 'Juan', 'Carolina', 'Roberto', 'Ana', 'Diego', 'Lucía', 'Martín', 'Valentina', 'Santiago', 'Camila', 'Mateo', 'Sofía', 'Nicolás', 'Florencia', 'Tomás', 'Paula', 'Agustín', 'Daniela', 'Federico'];
const CITIES = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'Tucumán', 'La Plata', 'Mar del Plata', 'Salta', 'Santa Fe', 'San Juan', 'Neuquén', 'Bahía Blanca', 'Posadas', 'Paraná', 'Jujuy', 'Formosa', 'San Luis', 'Tandil', 'Ushuaia', 'Río Cuarto'];
export function BuyerPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [buyer, setBuyer] = useState({
    name: '',
    city: '',
    timeAgo: 0
  });
  useEffect(() => {
    const initialTimeout = setTimeout(() => {
      showRandomBuyer();
    }, 5000);
    return () => clearTimeout(initialTimeout);
  }, []);
  const showRandomBuyer = () => {
    const name = NAMES[Math.floor(Math.random() * NAMES.length)];
    const city = CITIES[Math.floor(Math.random() * CITIES.length)];
    const timeAgo = Math.floor(Math.random() * 15) + 1;
    setBuyer({
      name,
      city,
      timeAgo
    });
    setIsVisible(true);
    setTimeout(() => {
      setIsVisible(false);
      const nextInterval = Math.floor(Math.random() * 15000) + 20000;
      setTimeout(showRandomBuyer, nextInterval);
    }, 4000);
  };
  return <AnimatePresence data-id="element-36">
      {isVisible && <motion.div initial={{
      x: -100,
      opacity: 0,
      y: 20
    }} animate={{
      x: 0,
      opacity: 1,
      y: 0
    }} exit={{
      x: -100,
      opacity: 0,
      y: 20
    }} className="fixed bottom-4 left-4 z-40 max-w-[300px] md:max-w-sm bg-white rounded-2xl shadow-xl border-2 border-green-100 p-4 flex items-start gap-3" data-id="element-37">
          <button onClick={() => setIsVisible(false)} className="absolute top-2 right-2 text-gray-300 hover:text-gray-500" data-id="element-38">
            <X className="w-4 h-4" data-id="element-39" />
          </button>

          <div className="bg-green-100 p-3 rounded-full flex-shrink-0 border border-green-200" data-id="element-40">
            <ShoppingCart className="w-5 h-5 text-green-600" data-id="element-41" />
          </div>

          <div data-id="element-42">
            <p className="text-sm font-bold text-gray-900" data-id="element-43">
              {buyer.name} de {buyer.city}
            </p>
            <p className="text-xs text-gray-600 mt-1" data-id="element-44">
              Compró el{' '}
              <span className="font-bold text-green-600" data-id="element-45">
                Mega Pack Anti-Pantallas
              </span>
            </p>
            <div className="flex items-center gap-1 mt-2" data-id="element-46">
              <CheckCircle2 className="w-3 h-3 text-green-500" data-id="element-47" />
              <p className="text-[10px] text-gray-400 uppercase tracking-wide font-bold" data-id="element-48">
                Hace {buyer.timeAgo} minutos
              </p>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}